import request from '@/api/request';
const defaultRequest = request();

export function getDevices (params) {
  return defaultRequest({
    url: '/device',
    method: 'get',
    params
  });
}

export function importDevices (data) {
  return defaultRequest({
    url: '/device/import',
    method: 'post',
    data
  });
}

export function moveDevices (data) {
  return defaultRequest({
    url: '/device/move',
    method: 'put',
    data
  });
}

export function returnDevices (data) {
  return defaultRequest({
    url: '/device/return',
    method: 'put',
    data
  });
}

export function changePlanCode (data) {
  return defaultRequest({
    url: '/device/changeplancode',
    method: 'put',
    data
  });
}

export function sendCommand (data) {
  return defaultRequest({
    url: '/device/sendcommand',
    method: 'post',
    data
  });
}

export function getCommand (params) {
  return defaultRequest({
    url: '/device/getcommand',
    method: 'get',
    params
  });
}

export function getPackets (params) {
  return defaultRequest({
    url: '/device/getpackets',
    method: 'get',
    params
  });
}

export function getDeviceHistory (params) {
  return defaultRequest({
    url: '/device/history',
    method: 'get',
    params
  });
}

export function renew (data) {
  return defaultRequest({
    url: '/device/renew',
    method: 'post',
    data
  });
}

export function updateLastWaypoint (data) {
  return defaultRequest({
    url: '/device/updatelastwaypoint',
    method: 'post',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/device.js